<div class="d-flex gap-5 flex-column">
    <div *ngFor="let content of sharedContentsListCopy">
        <div class="row hero-image-card">
            <div class="col-md-12">
                <div class="card card-custom gutter-b card-stretch">
                    <div class="card-body">
                        <div class="d-flex justify-content-end">
                            <app-shared-content-add-update
                                *ngIf="hideEditOption === true"
                                [generalTabIndex]="generalTabIndex"
                                [sharedContentType]="sharedContentType"
                                [language]="language"
                                [sharedContent]="content"
                                (refreshSharedContentsCreate)="refreshDataHandler($event)"
                                (refreshSharedContentsUpdate)="refreshDataHandler($event)"
                            ></app-shared-content-add-update>
                            <app-shared-content-remove
                                *ngIf="hideDeleteOption === true"
                                [generalTabIndex]="generalTabIndex"
                                [sharedContentId]="content.sharedContentId"
                                (refreshSharedContents)="refreshDataHandler($event)"
                            >
                            </app-shared-content-remove>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card-body" style="padding: 0px">
                                    <div *ngIf="content.image" class="edit_banner_img">
                                        <img mat-card-image [src]="content.image" alt="upload-image" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-8">
                                <div class="card-body" style="position: relative; padding: 10px 20px 0px">
                                    <div *ngIf="generalTabIndex == 1" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TYPE' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TYPE' | transloco }}"
                                                value="{{ content.sharedContentType?.value }}"
                                                name="type"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div *ngIf="generalTabIndex == 1 || generalTabIndex == 2" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TITTLE' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.TITTLE' | transloco }}"
                                                value="{{ content.heading }}"
                                                name="title"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.IMAGE_LOCATION' | transloco }} :</mat-label>
                                        <div class="d-flex">
                                            <div class="checkbox">
                                                <mat-checkbox
                                                    class="checkbox-wrapper checkbox-disable"
                                                    [checked]="content.imageLocation == 2 || content.imageLocation == 3"
                                                    [disabled]="true"
                                                    >{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.LANDING_PAGE' | transloco }}</mat-checkbox
                                                >
                                            </div>
                                            <div class="checkbox ms-5">
                                                <mat-checkbox
                                                    class="checkbox-wrapper checkbox-disable"
                                                    [checked]="content.imageLocation == 1 || content.imageLocation == 3"
                                                    [disabled]="true"
                                                    >{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.HOME_PAGE' | transloco }}</mat-checkbox
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.HEADING' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.HEADING' | transloco }}"
                                                value="{{ content.heading }}"
                                                name="heading"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 0" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.SUB_HEADING' | transloco }}</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.SUB_HEADING' | transloco }}"
                                                value="{{ content.subHeading }}"
                                                name="sub_heading"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 2" style="width: 100%" class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DESCRIPTION' | transloco }} </mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DESCRIPTION' | transloco }}"
                                                value="{{ content.subHeading }}"
                                                name="sub_heading"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div *ngIf="generalTabIndex == 2" class="mb-3">
                                        <div style="width: 100%; margin-bottom: 20px; display: table">
                                            <div class="btn-group custom-toggle-wrap" role="group">
                                                <label *ngFor="let opt of stateOptions" class="btn custom-toggle" [class.active]="opt.value === content.method">
                                                    <input
                                                        type="radio"
                                                        class="btn-check"
                                                        name="isPurchase"
                                                        [value]="opt.value"
                                                        [(ngModel)]="content.method"
                                                        autocomplete="off"
                                                        [disabled]="true"
                                                    />

                                                    {{ opt.label }}
                                                </label>
                                            </div>
                                        </div>
                                        <div *ngIf="content.isPurchase == true">
                                            <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.PRICE' | transloco }} :</mat-label>
                                            <mat-form-field class="example-full-width custom-text-field">
                                                <input
                                                    type="text"
                                                    matInput
                                                    placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.PRICE' | transloco }}"
                                                    value="{{ content.price }}"
                                                    name="price"
                                                    readonly
                                                />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_TEXT' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_TEXT' | transloco }}"
                                                value="{{ content.navigationText }}"
                                                name="navigation_text"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div class="mb-3">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_LINK' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.NAVIGATION_LINK' | transloco }}"
                                                value="{{ content.navigationLink }}"
                                                name="navigation_link"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>

                                    <div class="mb-3" *ngIf="generalTabIndex == 1" style="width: 100%">
                                        <mat-label class="font-style">{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DATE' | transloco }} :</mat-label>
                                        <mat-form-field class="example-full-width custom-text-field">
                                            <input
                                                type="text"
                                                matInput
                                                placeholder="{{ 'SETTING_PAGE.GENRAL_SETTINGS.LABALS.DATE' | transloco }}"
                                                value="{{ content.date | date: 'fullDate' }}"
                                                name="date"
                                                readonly
                                            />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
